<h2 mat-dialog-title>Input Method</h2>

<mat-dialog-content>
  <div class="main-layout-wrapper">
    <section class="content-area">
      <div class="search-container">
        <div class="search-bar">
          <span class="search-icon">🔍</span>
          <input
            type="text"
            class="search-input"
            placeholder="Search all element types"
            (input)="onSearch($event)"
          />
        </div>
      </div>

      <div class="question-type-grid">
        @for (type of filteredTypes(); track type.key) {
        <div
          class="question-type-card"
          (click)="!type.config.deactivate && selectElementType(type.key)"
          [class.selected]="selectedType() === type.key"
          [class.disabled]="type.config.deactivate"
          role="button"
          tabindex="0"
        >
          <img [src]="type.config.icon_path" [alt]="type.config.title" />
          <div class="question-type-label">{{ type.config.title }}</div>
        </div>
        }
      </div>
    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  <button
    mat-stroked-button
    class="primary-btn"
    (click)="create()"
    [disabled]="!selectedType()"
  >
    Create
  </button>
</mat-dialog-actions>
